import React from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import ActionCreator from "../ActionCreator";
import ProfileForm from "./ProfileForm";
import InvoiceForm, {
  CATEGORIES,
  CARRIER_TYPE,
  valid as invoiceValid,
} from "./InvoiceForm";
import * as Cart from "../Contexts/CartContext";
import * as Theme from "../Theme";
import * as Ant from "antd";

const Wrapper = styled.div`
  margin: 20px;

  & h2 {
    color: #5a5a5a;
    margin-bottom: 10px;
    font-size: 21px;
  }

  & > .form-wrapper {
    border: 0.5px solid #ccc;
    background-color: #fff;
    padding: 20px;
  }

  & .title {
    padding: 8px 10px;
    font-size: 16px;
    background-color: ${Theme.colors.main};
    color: #fff;
    margin-bottom: 20px;
  }
`;

const Button = styled.div`
  padding: 10px 30px;
  background-color: ${props => props.color || Theme.colors.main};
  color: #fff;
  border-radius: 3px;
  font-weight: 600;
  cursor: pointer;
  font-size: 13px;

  ${props => props.css}
`;

class ProfilePanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      config: null,
      doValidate: false,
    };
  }

  async componentDidMount() {
    this._getConfig();
  }

  async componentDidUpdate(prevProps) {
    if (!prevProps.cart.data && this.props.cart.data) {
      this._getConfig();
    }
  }

  render() {
    let { config, doValidate } = this.state;

    return (
      <Wrapper>
        <h2>會員基本資料</h2>
        <div className="form-wrapper">
          <div className="title">會員基本資料</div>
          <ProfileForm /> {/* use old sensation repo comps below this layer */}
          <div className="title">發票資訊</div>
          {config && (
            <div>
              <InvoiceForm
                config={config}
                setConfig={obj => {
                  console.log("chnage", obj);
                  this.setState(
                    {
                      config: {
                        ...this.state.config,
                        ...obj,
                      },
                    },
                    () => console.log("after: ", this.state.config)
                  );
                }}
              />
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  paddingRight: 20,
                }}
              >
                <Button onClick={this._editInvoice}>修改發票資訊</Button>
              </div>
            </div>
          )}
        </div>
      </Wrapper>
    );
  }

  _editInvoice = async () => {
    let { config } = this.state;

    try {
      invoiceValid(config);
      let resp = await Cart.Actions.editConfig(config);
      Ant.message.success("修改成功");
    } catch (ex) {
      console.warn(ex);
      Ant.message.error("修改失敗");
    }
    this.setState({ doValidate: false });
  };

  _getConfig = async () => {
    let { cart } = this.props;
    try {
      let resp = cart.data;
      console.log("resp>>>", resp);
      if (resp && resp.config.category) {
        this.setState({ config: resp.config });
      } else {
        this.setState({
          config: {
            category: CATEGORIES.two_copies.value,
            uni_no: "",
            company_title: "",
            carrier_type: CARRIER_TYPE.default.value,
            carrier_num: "",
          },
        });
      }
      return resp;
    } catch (ex) {
      console.warn("fetchCart error", ex);
    }
  };
}

export default connect(null, ActionCreator)(Cart.withConsumer(ProfilePanel));
